import { Hitbox } from "@ortho-next/three-base";
import { CircleGeometry, Mesh, MeshBasicMaterial } from "three";
import { Consts } from "../../Utils/Consts.js";
import { Default } from "../../Utils/Default.js";
import { VectorUtils } from "../../Utils/VectorUtils.js";
import { AnatomicalAxisType } from "./AnatomicalAxis.js";
export class ConvexityPoint extends Mesh {
    get convexityValue() {
        return this._convexityValue;
    }
    constructor(name, viewType, A1, A2, convexityValue, axisType) {
        super(ConvexityPoint.geometry, ConvexityPoint.material);
        this.name = name;
        this._convexityValue = convexityValue;
        this.position.copy(A1.position.clone().lerp(A2.position, convexityValue));
        this.interceptedByRaycaster = true;
        this.cursorOnHover = this.getCursorName(convexityValue, axisType);
        this.registerHitbox(new Hitbox(ConvexityPoint.geometry));
        Default.scaleByScaleFactorPoints(this);
        Default.bindHitboxScaleByScaleFactorAndZoom(viewType, this);
        this.bindEvent("onHover", () => {
            this.add(Default.smallDonut);
        });
        this.bindEvent("onLeave", () => {
            this.remove(Default.smallDonut);
            this.needsRender = true;
        });
        A1.bindEvent("onPositionComponentChange", () => { this.position.lerpVectors(A1.position, A2.position, convexityValue); });
        A2.bindEvent("onPositionComponentChange", () => { this.position.lerpVectors(A1.position, A2.position, convexityValue); });
        this._visible = true; // patch to fix history
    }
    select() {
        const dirVector1 = this.parent.A2.position.clone().sub(this.parent.A1.position);
        const length = dirVector1.length();
        const newAc = this.parent.Ac.position.clone();
        const newA1 = newAc.clone().sub(dirVector1.setLength(length * this._convexityValue));
        if (!this.fixNewPointIfInvalid(newA1)) {
            newAc.addVectors(newA1, dirVector1);
        }
        const newA2 = newAc.clone().add(dirVector1.setLength(length * (1 - this._convexityValue)));
        if (!this.fixNewPointIfInvalid(newA2)) {
            newAc.subVectors(newA2, dirVector1);
            newA1.subVectors(newAc, dirVector1.setLength(length * this._convexityValue));
        }
        if (!newAc.equals(this.parent.Ac.position)) {
            const dirAB = this.parent.A.position.clone().sub(this.parent.B.position).setLength(this.parent.A.position.distanceTo(this.parent.Ac.position));
            this.parent.Ac.position.copy(newAc);
            this.parent.A.position.addVectors(newAc, dirAB);
            this.parent.center.position.lerpVectors(newAc, this.parent.middlePointB1B2.position, 0.5);
        }
        this.parent.A1.position.copy(newA1);
        this.parent.A2.position.copy(newA2);
        this.visible = false;
        return this._convexityValue;
    }
    unselect() {
        this.visible = true;
    }
    /**
     * Checks if new point goes beyond B1 B2 line and fix it.
     */
    fixNewPointIfInvalid(point) {
        if (!VectorUtils.arePointsOnSameSide(this.parent.B1.position, this.parent.B2.position, Consts.planeNormal, this.parent.Ac.position, point)) {
            point.copy(VectorUtils.lines2DIntersection(this.parent.B1.position, this.parent.B2.position, point, point.clone().add(this.parent.A.position.clone().sub(this.parent.B.position))));
            return false;
        }
        return true;
    }
    getCursorName(convexityValue, axisType) {
        const conv = Math.round(1 / (convexityValue > 0.5 ? 1 - convexityValue : convexityValue));
        return `images/labels/Conv_1_${conv}_icon_${axisType === AnatomicalAxisType.moving ? "mov" : "ref"}.cur`;
    }
}
ConvexityPoint.geometry = new CircleGeometry(0.4, 15);
ConvexityPoint.material = new MeshBasicMaterial({ color: 0xff0000, transparent: true, opacity: 0.8 });
//# sourceMappingURL=ConvexityPoint.js.map